<template>
  <div class="basic-info">
    <div class="patient-info">
      <div class="info-content">
        <div class="info-item">患者姓名：{{ this.currentPatientInfo.patientName }}</div>
        <div class="info-item" style="width: 40%">随访状态： {{this.currentPatientInfo.followUpStateName}}</div>
        <div class="info-item">住院号：{{this.currentPatientInfo.hospitalId}}</div>
      </div>
      <div class="audio-content">
        <div v-if="showAudio" class="audio-container">
            <i @click="showAudio = false" class="el-icon el-icon-close close"></i>
            <vue-audio-player v-if="audio" ref="audio" :src="audio" :key="timer"></vue-audio-player>
        </div>
      </div>
      <div class="audio-list">
          <div class="audio-list-item" v-for="(item, index) in patientCallRecord" :key="index">
              <span>{{item.relationshipRemarks?item.relationshipRemarks:'暂无'}}</span><span>{{item.calledPhoneNumber}}</span>
              <span>{{item.callStateName}}</span><span>{{item.followUpDate}}</span><span>{{item.callSeat}}</span>
              <el-button v-if="item.isRecording || item.recording" @click="getAudio(item)"
                        size="mini" type="text">听录音
              </el-button>
              <el-button v-else disabled size="mini" type="text">
                  暂无录音
              </el-button>
          </div>
      </div>
    </div>
    <div class="task-info">
      <el-tabs v-model="tabActiveName" @tab-click="handleTabSelect">
        <el-tab-pane label="患者详情" name="0">
          <el-tabs
            v-model="subtabActiveName"
            @tab-click="handleSubTabSelect"
            class="subtab-container"
          >
            <el-tab-pane label="基础信息" name="0-1">
              <div class="patient-basic-info">
                姓名：<span>{{ patientInfoFromApi.userName }}</span
                ><br />
                性别：<span>{{ patientInfoFromApi.userSex }}</span
                ><br />
                住院号：<span>{{ patientInfoFromApi.admitNo }}</span
                ><br />
                年龄：<span>{{ patientInfoFromApi.userAge }}</span
                ><br />
                治疗方式：<span>{{ patientInfoFromApi.treatment }}</span
                ><br />
                出院日期：<span>{{ patientInfoFromApi.dischargeTime }}</span
                ><br />
                疾病名称：<span>{{ patientInfoFromApi.diseaseName }}</span>
                <el-divider></el-divider>
                <div>
                  <div v-for="(item, index) in patientInfoFromApi.resourcesData" :key="index">
                    {{item.key}}：{{item.value}}
                  </div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="往期随访" name="0-2">
              <div v-if="historyFollowupList.length == 0 && emptyState.historyFollowup" class="qc-empty">
                <img src="../img/no-result.png" alt="loading" style="width:180px;margin-bottom: 20px;">
                <span style="margin-bottom: 20px;">暂无往期随访</span>
              </div>
              <div v-if="historyDetailShow">
                <el-button type="primary" size="mini" @click="historyDetailShow=false">返回</el-button>
                <div v-for="(item,index) in historyFollowupDetail" :key="index" style="width:60%">
                    <div style="text-align:left;padding: 10px;">{{item.header}}</div>
                    <div class="history-detail-item" v-for="(_item,_index) in item.followupInfoKV" :key="_index">
                        <div>{{_item.infoKey}}</div>
                        <div>{{_item.infoValue}}</div>
                    </div>
                </div>
              </div>
              <div v-else v-for="(item, index) in historyFollowupList" :key="index">
                <div class="history-item" @click="goHistoryDetail(item)">
                  随访任务：<span>{{ item.taskName }}</span
                  ><br />
                  随访时间：<span>{{ item.createTime }}</span
                  ><br />
                  随访结果：<span>{{ item.followupStateName }}</span>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="住院信息" name="0-3">
              <div v-if="patientMedicalRecord.length == 0 && emptyState.patientMedical" class="qc-empty">
                <img src="../img/no-result.png" alt="loading" style="width:180px;margin-bottom: 20px;">
                <span style="margin-bottom: 20px;">暂无住院信息</span>
              </div>
              <div v-for="(item, index) in patientMedicalRecord" :key="index">
                <div class="history-item">
                  就诊科室：<span>{{ item.departmentName }}</span
                  ><br />
                  就诊时间：<span>{{ item.visitingDate }}</span
                  ><br />
                  就诊类别：<span>{{ item.departmentName }}</span>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </el-tab-pane>
        <el-tab-pane label="随访记录" name="1">
          <el-tabs
            v-model="subtabActiveName"
            @tab-click="handleSubTabSelect"
            class="subtab-container"
          >
            <el-tab-pane label="随访备注" name="1-1">
               <!-- <div v-if="patientTag == []" class="qc-empty">
                <img src="../img/no-result.png" alt="loading" style="width:180px;margin-bottom: 20px;">
                <span style="margin-bottom: 20px;">暂无随访备注</span>
              </div> -->
              <!-- <el-button type="primary" @click="submitResult" size="mini" plain>保存备注</el-button> -->
              <div>
                <UserRemarkN ref="userRemarkN" :taskId="this.taskId" :patientData="currentPatientInfo"  :key="timer"></UserRemarkN>
              </div>
            </el-tab-pane>
            <el-tab-pane label="短信记录" name="1-2">
              <div v-if="smsSendRecord.length == 0 && emptyState.smsSend" class="qc-empty">
                <img src="../img/no-result.png" alt="loading" style="width:180px;margin-bottom: 20px;">
                <span style="margin-bottom: 20px;">暂无短信记录</span>
              </div>
              <div v-for="(item, index) in smsSendRecord" :key="index">
                <div class="history-item">
                  发送人：<span>{{ item.userName }}</span
                  ><br />
                  接收号码：<span>{{ item.phoneNumber }}</span
                  ><br />
                  发送时间：<span>{{ item.crateTime }}</span
                  ><br />
                  短信内容：<span>{{ item.messageInfo }}</span
                  ><br />
                  短信状态：发送<span
                    :class="
                      item.sendStatus == '成功' ? 'success-font' : 'error-font'
                    "
                    >{{ item.sendStatus }}</span
                  >
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </el-tab-pane>
        <el-tab-pane label="质控记录" name="2"
          >
          <el-tabs
            v-model="subtabActiveName"
            @tab-click="handleSubTabSelect"
            class="subtab-container"
            style="position:relative"
          >
            <el-tab-pane label="质控详情" name="2-1">
              <QualityControlDetail :patientInfo="currentPatientInfo" :key="timer" ref="QualityControlDetail" @wantAddQc="wantAddQc" :getCheckResult="getCheckResult"></QualityControlDetail>
            </el-tab-pane>
            <el-tab-pane label="我要质控" name="2-2">
              <el-alert v-if="patientInfoFromApi.latelyFollowupState == 0 || patientInfoFromApi.latelyFollowupState == 6" title="随访待开始患者不可进行质控" type="warning"  show-icon :closable="false"></el-alert>
              <EditResult v-else type="add" ref="EditResult" :currentPatientInfo="currentPatientInfo" :seatId="seatId" @hadAddQc="hadAddQc"></EditResult>
            </el-tab-pane>
          </el-tabs>
          <span class="rule-instruction" @click="drawer = true">
            <i class="el-icon-question"></i>
            质控规则
          </span>
        </el-tab-pane>
      </el-tabs>
      <!-- 质控规则 -->
      <RuleInstruction :drawerSon="drawer" @closeDrawer="closeDrawer" :followupTaskId="taskId"></RuleInstruction>
    </div>
  </div>
</template>

<script>
import vueAudioPlayer from '../../AudioPlayer/vueAplayerN.vue'
import QualityControlDetail from './QualityControlDetail'
import EditResult from "./EditResult.vue";
import RuleInstruction from "../RuleInstruction"
import {
RestReferenceControllerGetPatientInfoManager, //基础信息
RestReferenceControllerGetAllFollowupList, //往期随访
RestFeedbackOutControllerGetPatientMedicalRecordList, //住院信息
RestReferenceControllerGetSmsSendRecordPatientInfo, //短信记录
RestReferenceControllerGetDeliver,
RestCallCenterPersonTagsControllerGetPatientTags, //备注
RestReferenceControllerGetPatientCallRecord, //呼叫记录
} from '@src/assets/js/api.js'
// import UserRemark from '../../patient/showRemark.vue'
import UserRemarkN from '../../patient/UserRemarkN.vue'

export default {
  name: 'QualityControlOperation',
  props: ['patientInfo'],
  data() {
    return {
      tabActiveName: '0',
      subtabActiveName: '0-1',
      currentPatientInfo: this.patientInfo,
      patientInfoFromApi: {},
      historyFollowupList: [],
      patientMedicalRecord: [],
      patientCallRecord: [],
      smsSendRecord: [],
      relationShipList:[], //呼叫记录中的
      subTabName: '0-1', //质控记录-质控详情刷新
      audio: '',
      showAudio: false,
      drawer: false,
      historyDetailShow: false, //往期随访---展示随访详情
      historyFollowupDetail: [],
      timer: null,
      seatId: null,
      taskId: localStorage.getItem('taskId'),
      emptyState:{ //空状态
        historyFollowup: false,
        patientMedical: false,
        smsSend: false,
      },
      patientTag: null,
      // 保留tab的二级状态-初始化
      tabHistory:{
        '0':'0-1',
        '1':'1-1',
        '2':'2-1',
      }
    }
  },
  components: {vueAudioPlayer,QualityControlDetail,EditResult,RuleInstruction,UserRemarkN},
  watch:{
    patientInfo: function(newval, oldval){
      this.currentPatientInfo = newval;
      console.log('patientInfo---->',newval)
      if(newval != oldval ){
        this.tabActiveName= '0',
        this.subtabActiveName= '0-1',
        this.onload()
      }
    }
  },
  mounted() {
    this.onload()
  },
  methods: {
    onload() {
      console.log('currentPatientInfo---->',this.currentPatientInfo)
      this.getPatientInfoManager();
      this.getPatientCallRecord();
    },
    getPatientCallRecord() {
      this.patientCallRecord = []
      this.getPatientCallRecordAsync().then((res) => {
        this.seatId = res.retValue.length == 0? null: res.retValue[0].callSeatId
        this.patientCallRecord = res.retValue.map((item) => {
          item.callStateName = this.getCallState(item.callStateId)
          item.audioChecked = false
          return item
        })
        // this.patientCallRecord.length > 0?this.audioCheckedData = this.patientCallRecord[0]: ''
        // console.log('audioCheckedData===>', this.audioCheckedData)
        // // 录音播放器默认显示
        // let recordFilter =  res.retValue.filter(item => {
        //   return item.recording != ""
        // })
        // recordFilter.length > 0?this.getAudio(recordFilter[0]): ''
      })
    },
    getAudio(param) {
      this.audio = ''
      this.timer= new Date().getTime()
      if(param.isRecording){
        this.showAudio = true
        this.audio = JSON.parse(param.recording)
        setTimeout(() => {
            this.$refs.audio.startPlayOrPause()
        }, 1000)
      }else {
        this.showAudio = false
        this.$message.error('暂无录音')
      }
    },
    handleTabSelect(tab, event) {
      this.historyDetailShow = false;
      // switch (tab.name) {
      //   case '0':
      //     this.getPatientInfoManager()
      //     break
        // case '1':
        //   // this.getPatientTags()
        //   break
        // case '2':
        //   this.subTabName = '2-1'
        //   break
      // }
      this.subtabActiveName =  this.tabHistory[tab.name]
    },
    handleSubTabSelect(tab, event) {
      this.historyDetailShow = false;
      this.subtabActiveName = tab.name
      // 记录二级tab
      this.tabHistory[this.tabActiveName] = tab.name
      switch (tab.name) {
        case '0-1':
          this.getPatientInfoManager()
          break
        case '0-2':
          this.getAllFollowupList()
          break
        case '0-3':
          this.getPatientMedicalRecord()
          break
        case '1-3':
          this.getSmsSendRecord()
          break
        default:
          break
      }
    },
    // 我要质控
    wantAddQc(){
      this.subtabActiveName = '2-2'
      this.$refs.EditResult.resetForm()
    },
    // 如果质控记录没有，直接到【我要质控】
    getCheckResult(){
      if (this.tabActiveName == '2') {
        this.subtabActiveName = '2-2'
      }
        this.tabHistory['2'] = '2-2'
    },
    hadAddQc(){
      // this.subTabName = '2-1'
      this.subtabActiveName = '2-1'
      this.timer= new Date().getTime()
    },
    closeDrawer(){
      this.drawer = false;
    },
    getPatientInfoManager() {
      let vm = this
      vm.getPatientInfoManagerAsync().then((res) => {
        vm.patientInfoFromApi = res.retValue;
        vm.patientInfoFromApi.resourcesData = vm.patientInfoFromApi.referenceInfo.keyValue==""?[]:JSON.parse(vm.patientInfoFromApi.referenceInfo.keyValue)
        // vm.$emit('getPatientBasicInfo', res.retValue)  // 用于判断新旧问卷的显示
      })
    },
    getAllFollowupList() {
      this.getAllFollowupListAsync().then((res) => {
        if (res.retValue.length == 0) {
          this.emptyState.historyFollowup =true
        }else {
          this.historyFollowupList = res.retValue.map(item => {
            // this.$store.dispatch('getFollowupStatus', {status: item.followupState})
            //     .then(status => {
            //         item.followupStateName = status
            //     })
            item.followupStateName = this.getFollowupStatus(item.followupState)
            return item
          })
        }
      })
    },
    // 往期随访
    goHistoryDetail(param) {
      this.historyDetailShow = true;
      this.historyFollowupDetail = []
      this.getDeliverAsync(param).then(res => {
        this.historyFollowupDetail = res.retValue
      })
    },
    getPatientMedicalRecord() {
      console.log('住院信息')
      this.getPatientMedicalRecordAsync().then((res) => {
        if (res.retValue.length == 0) {
          this.emptyState.patientMedical =true
        }else {
          this.patientMedicalRecord = res.retValue.map((item) => {
            item.visitingType = this.getVisitingType(item.visitingType)
            return item
          })
        }
      })
    },
    getSmsSendRecord() {
      console.log('短信记录')
      this.getSmsSendRecordAsync().then((res) => {
        if (res.retValue.length == 0) {
          this.emptyState.smsSend =true
        }else {
          this.smsSendRecord = res.retValue
        }
      })
    },
    // 获取门诊类别
    getVisitingType(state) {
      switch (state) {
        case 0:
          return '门诊'
          break
        case 1:
          return '住院'
          break
        case 2:
          return '体检'
          break
      }
    },
    getCallState(state) {
      switch (state) {
        case 1:
          return '稍后拨打'
          break
        case 2:
          return '仅随访该患者'
          break
        case 3:
          return '短信随访成功'
          break
        case 4:
          return '电话随访成功'
          break
        case 5:
          return '初始化'
          break
        case 6:
          return '挂断（接通）'
          break
        case 7:
          return '无人接听'
          break
        case 8:
          return '挂断（未接通）'
          break
        case 9:
          return '停机'
          break
        case 10:
          return '关机'
          break
        case 11:
          return '拒随'
          break
        case 12:
          return '空号'
          break
        case 13:
          return '错号'
          break
        case 14:
          return '不知情'
          break
        case 15:
          return '沟通不畅'
          break
      }
    },
    getFollowupStatus(status) {
        let followUpStatus = [
            {label: '短信随访未开始', value: 1},
            {label: '短信发送1次', value: 2},
            {label: '短信发送2次', value: 3},
            {label: '短信转电话随访', value: 4},
            {label: '短信随访完成', value: 5},
            {label: '随访待开始', value: 6},
            {label: '电话随访未完成', value: 7},
            {label: '电话随访稍后拨打', value: 8},
            {label: '电话随访完成', value: 9},
            {label: '失访', value: 10},
            {label: '未成功', value: 11},
            {label: '死亡', value: 12},
            {label: '异常号码', value: 13},
            {label: '沟通不畅', value: 16},
            {label: '拒绝随访（有信息）', value: 17},
            {label: '拒绝随访（无信息）', value: 18},
        ]
        return followUpStatus.find(item => item.value == status) ? followUpStatus.find(item => item.value == status).label : '-'
    },

    // ========================获取数据===========================
    // 呼叫记录
    async getPatientCallRecordAsync() {
      let request = new RestReferenceControllerGetPatientCallRecord()
      request.p_followupPatientId = this.currentPatientInfo.followupPatientId
      request.p_followUpTaskId = this.taskId
      await request.send()
      return request.result
    },
    // 患者详情--基础信息
    async getPatientInfoManagerAsync() {
      let request = new RestReferenceControllerGetPatientInfoManager()
      request.p_followupTaskId = this.taskId
      request.p_followupPatientId = this.currentPatientInfo.followupPatientId
      request.p_patientId = this.currentPatientInfo.patientId
      request.p_followUpPatientInfoId =
        this.currentPatientInfo.followupPatientInfoId
      await request.send()
      return request.result
    },
    // 患者详情--往期随访
    async getAllFollowupListAsync() {
      let request = new RestReferenceControllerGetAllFollowupList()
      request.p_followupPatientId = this.currentPatientInfo.followupPatientId
      await request.send()
      return request.result
    },

    // 患者详情--住院信息
    async getPatientMedicalRecordAsync() {
      let request =
        new RestFeedbackOutControllerGetPatientMedicalRecordList()
      request.p_patientId = this.currentPatientInfo.patientId
      request.p_page = 1
      await request.send()
      return request.result
    },
    //随访记录--短信记录
    async getSmsSendRecordAsync() {
      let request =
        new RestReferenceControllerGetSmsSendRecordPatientInfo()
      request.p_followupPatientId = this.currentPatientInfo.followupPatientId
      request.p_followUpTaskId = this.taskId
      await request.send()
      return request.result
    },
     // 往期随访详情
    async getDeliverAsync(p) {
      let request = new RestReferenceControllerGetDeliver()
      request.p_followupPatientId = this.currentPatientInfo.followupPatientId*1
      request.p_taskId = p.taskId
      await request.send()
      return request.result
    },
    async getPatientTags() {
      let request = new RestCallCenterPersonTagsControllerGetPatientTags()
      request.p_followUpPatientId = this.currentPatientInfo.followupPatientId
      request.p_followUpTaskId = this.taskId
      await request.send()
      if(request.result.status == 0) {
          this.patientTag = JSON.parse(request.result.retValue)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.basic-info {
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: 26% 74%;
  height: 100%;
  .patient-info {
    border: 1px solid #ccc;
    border-radius: 5px;
    padding: 10px;
    height: 100%;
    overflow: auto;
    .info-content {
      display: flex;
      font-weight: bold;
      .info-item{
        width: 30%;    
        height: 30px;
        line-height: 30px;
        span {
          color: #000;
        }

      }
    }
    .audio-content {
      .audio-container {
        position: relative;
        padding-top: 15px;
        .close {
            cursor: pointer;
            position: absolute;
            right: 0;
            top: 0;
            font-weight: 700;
        }
    }
    }
    .audio-list {
      padding: 5px 6px;
      .audio-list-item {
        // display: flex;
        // justify-content: space-between;
        display: grid;
        grid-template-columns: 80px 120px 120px 150px auto 60px;
        align-items: center;
        font-size: 14px;
        cursor: pointer;
      }
      .audio-list-item:hover{
        background: #FFF4D1;
      }
    }
    
  }
  .task-info {
    .subtab-container {
      border: 1px solid #ccc;
      border-radius: 5px;
      padding: 0 10px;
      font-size: 14px;
      height: calc(100vh - 415px);
      overflow: auto;
      // 患者详情-基础信息
      .patient-basic-info {
        padding: 15px 0;
        line-height: 25px;
        span {
          color: #000;
        }
      }
    }
      .rule-instruction {
        position: absolute;
        top: 8px;
        right: 15px;
        z-index: 10;
        cursor: pointer;
      }
    .history-item {
      margin: 10px 0;
      padding: 10px;
      line-height: 26px;
      border-radius: 8px;
      span {
        color: #000;
      }
      .success-font {
        color: #196ad4;
      }
      .error-font {
        color: #ff2929;
      }
    }
    .history-item:hover {
      background: #f4f4f4;
    }
    .qc-empty {
        height: 100%;
        display: flex;
        padding-top: 5%;
        align-items: center;
        flex-direction: column;
      }
  }
  .history-detail-item {
        display: flex;
        align-items: center;
        justify-content: space-around;
        padding: 10px;
        border-bottom: 1px solid #ccc;
        .cursor {
            cursor: pointer;
            color: #248cfa;
        }
        div {
            width: 30%;
            text-align: center;
        }
        &:last-child {
            border-bottom: none;
        }
  }
}
</style>
<style lang="scss">
.basic-info .task-info {
  .el-tabs__header {
    margin-bottom: 5px;
  }
  // 修改Tab样式
  .el-tabs__nav-wrap {
    &::after {
      display: none;
    }
  }
  .el-divider--horizontal {
    margin: 15px 0;
  }
}
</style>
